import { render } from "./HumanActivity.vue?vue&type=template&id=6c5ccf34"
import script from "./HumanActivity.vue?vue&type=script&lang=js"
export * from "./HumanActivity.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/coastal-watchers-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__